export enum LANGUAGE_ENUM {
  EN = 'en',
  AR = 'ar',
}

export const ALLOWED_LANGUAGES = Object.values(LANGUAGE_ENUM);
